import { render, staticRenderFns } from "./Pos_promotion_detail.vue?vue&type=template&id=a7fd25f6&scoped=true&"
import script from "./Pos_promotion_detail.vue?vue&type=script&lang=js&"
export * from "./Pos_promotion_detail.vue?vue&type=script&lang=js&"
import style0 from "./Pos_promotion_detail.vue?vue&type=style&index=0&id=a7fd25f6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a7fd25f6",
  null
  
)

export default component.exports